import * as AppSettingsActions from '../actions';

import {createReducer, on} from '@ngrx/store';
import {AppSetting} from '@app/core/models';

export const APPSETTINGS_INITIAL_STATE: AppSetting = {
  TargetAppVersion: '',
  UpdateIsRequired: false,
  CartCount: 0,
  NotificationCount: 0,
  HomeSettings: {
    HomeCategories: [],
    ShowBottomBanner: false,
    ShowMostSelling: false,
    ShowNewProducts: false,
    ShowTopBanner: false,
  },
  StartupTutorials: [],
};

export const appSettingsReducer = createReducer(
  APPSETTINGS_INITIAL_STATE,
  on(AppSettingsActions.StoreAppSettings, (state, { payload }) => {
    return {
      ...state,
      ...payload,
    };
  }),
  on(AppSettingsActions.LoadAppSettings, (state, { payload }) => {
    return {
      ...state,
      payload,
    };
  })
);
